var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"merchandising"},[_c('ProcessItem',{attrs:{"name":"Merchandising","header-color":"#9CB6C4"}},[_c('MiniProcess',{staticClass:"pre-sale",style:({
        marginLeft: _vm.preSalePosition,
        width: _vm.preSaleLength,
        minWidth: _vm.preSaleLength
      }),attrs:{"description":"Pre-Sale Period"}}),_c('MiniProcess',{staticClass:"demand-sale",attrs:{"description":"On-Demand Sales"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }